import { loadCSS } from '../../utils';
let view = null;

export default {
	namespace: 'template-home',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPDATA.themeUrl + '/dist/css/home.css');

		const { default: HomeView } = await import(/* webpackChunkName: "home-view" */ '../../templates/HomeView');
		view = new HomeView(next.container);
		view.init();

		if (trigger === 'barba') {
			document.dispatchEvent(new Event('animate-reveal'));
		} else {
			document.dispatchEvent(new Event('instant-reveal'));
		}
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
